import { allEnumValues, LocationRecommendationsLevel, PostAddUpsellType, RecommendationExperimentType, UpsizeUpsellDisplayStyle, UserRight, } from '@biteinc/enums';
import { AbstractModelSchema } from './abstract_model_schema.js';
export const recommendationVariationSchema = {
    displayName: 'recommendation variation',
    type: 'object',
    fields: {
        ...AbstractModelSchema.fields,
        orgId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        locationId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        name: {
            type: 'keyString',
            required: true,
        },
        recommendationsLevel: {
            type: 'int',
            enum: LocationRecommendationsLevel,
            values: allEnumValues(LocationRecommendationsLevel),
            displayName: 'Visibility level for per-item upsell',
            ui: 'dropdown',
            tooltip: {
                text: 'How prominently to show item recommendations when guests are looking at menu items.',
            },
            writeRight: UserRight.ManageBiteLift,
            required: true,
        },
        experimentType: {
            type: 'stringEnum',
            enum: RecommendationExperimentType,
            required: true,
            displayName: 'Experiment Type',
            defaultValue: RecommendationExperimentType.None,
        },
        experimentRuleIds: {
            displayName: 'Rules used in experiment',
            type: 'array',
            elementType: 'mongoId',
            ui: 'table',
            placeholder: 'Select Recommendation Rule',
            tooltip: {
                text: 'Rules that will be used in the experiment',
            },
            isNullable: true,
            required: true,
            minCount: 1,
            conditions: [
                {
                    field: 'experimentType',
                    values: [RecommendationExperimentType.RuleBased],
                },
            ],
        },
        recommendationRuleIds: {
            displayName: 'Rules in Pipeline',
            type: 'array',
            elementType: 'mongoId',
            ui: 'table',
            placeholder: 'Select Recommendation Rule',
            collapse: true,
            required: true,
        },
        weight: {
            type: 'int',
            required: true,
            min: 0,
            max: 100,
        },
        postAddUpsell: {
            type: 'array',
            elementType: 'object',
            required: true,
            ui: 'accordion',
            uiSubtype: 'PostAddUpsell',
            placeholder: 'Add a post add upsell',
            displayName: 'Post Menu Item Add To Cart Upsell',
            tooltip: {
                text: 'Select a modifier, and a set of menu items that will have the mod upsold on add to cart',
            },
            fields: {
                type: {
                    type: 'stringEnum',
                    enum: PostAddUpsellType,
                    required: true,
                },
                menuItemIds: {
                    type: 'array',
                    elementType: 'mongoId',
                    required: true,
                    ui: 'table',
                    placeholder: 'Select Menu Item',
                    displayName: 'Menu Items',
                },
                modifierMagicCopyKey: {
                    type: 'keyString',
                    ui: 'dropdown',
                    required: true,
                    displayName: 'Modifier to upsell',
                    conditions: [
                        {
                            field: 'type',
                            values: [PostAddUpsellType.Modifier],
                        },
                    ],
                },
                sectionIds: {
                    type: 'array',
                    elementType: 'mongoId',
                    ui: 'table',
                    required: true,
                    displayName: 'Sections to upsell',
                    placeholder: 'Select Section',
                    conditions: [
                        {
                            field: 'type',
                            values: [PostAddUpsellType.Section],
                        },
                    ],
                },
                applyFiltersFromPipeline: {
                    type: 'bool',
                    defaultValue: false,
                    displayName: 'Apply filters from pipeline',
                    conditions: [
                        {
                            field: 'type',
                            values: [PostAddUpsellType.Section],
                        },
                    ],
                },
            },
        },
        upsizeUpsell: {
            type: 'object',
            displayName: 'Upsize Upsell',
            isNullable: true,
            defaultValue: null,
            tooltip: {
                text: 'Offer guests the next size up for items with an upsize ladder ' +
                    '(detected from the POS or curated on the item).',
            },
            fields: {
                preAdd: {
                    type: 'bool',
                    defaultValue: false,
                    displayName: 'Offer in item view',
                    writeRight: UserRight.ManageBiteLift,
                },
                postAdd: {
                    type: 'bool',
                    defaultValue: false,
                    displayName: 'Prompt on add to cart',
                    writeRight: UserRight.ManageBiteLift,
                },
                atCheckout: {
                    type: 'bool',
                    defaultValue: false,
                    displayName: 'Offer in cart',
                    writeRight: UserRight.ManageBiteLift,
                },
                postAddDisplayStyle: {
                    type: 'stringEnum',
                    enum: UpsizeUpsellDisplayStyle,
                    ui: 'dropdown',
                    defaultValue: UpsizeUpsellDisplayStyle.Standard,
                    displayName: 'Add-to-cart prompt layout',
                    tooltip: {
                        text: 'Comparison shows the current and larger choices with an arrow and a target image when available.',
                    },
                    writeRight: UserRight.ManageBiteLift,
                },
                showPriceDifference: {
                    type: 'bool',
                    defaultValue: false,
                    displayName: 'Show price difference',
                    writeRight: UserRight.ManageBiteLift,
                },
                menuItemIds: {
                    type: 'array',
                    elementType: 'mongoId',
                    ui: 'table',
                    placeholder: 'Select Menu Item',
                    displayName: 'Menu Items',
                    tooltip: {
                        text: 'Only these items offer an upsize. Leave empty to offer none.',
                    },
                    writeRight: UserRight.ManageBiteLift,
                },
            },
            writeRight: UserRight.ManageBiteLift,
        },
    },
};
//# sourceMappingURL=recommendation_variation_schema.js.map